import request from '@/utils/request';

// 查看积分
export function getPoints(userId) {
    return request({
        url: '/api/points/get',
        method: 'get',
        params: { userId }
    });
}

// 增加积分
export function addPoints(data) {
    return request({
        url: '/api/points/add',
        method: 'post',
        data
    });
}

// 减少积分
export function deductPoints(data) {
    return request({
        url: '/api/points/deduct',
        method: 'post',
        data
    });
}

// 添加积分活动
export function addPointActivity(data) {
    return request({
        url: '/api/points/addPointActivity',
        method: 'post',
        data
    });
}

// 删除积分活动
export function deletePointActivity(activityId) {
    return request({
        url: '/api/points/deletePointActivity',
        method: 'post',
        data: {
            activityId
        }
    });
}

// 启用/禁用积分活动
export function togglePointActivityEnabled(data) {
    return request({
        url: '/api/points/toggleEnabled',
        method: 'post',
        data
    });
}

// 归档积分活动
export function archivePointActivity(activityId, reason) {
    return request({
        url: '/api/points/archivePointActivity',
        method: 'post',
        data: {
            activityId,
            reason
        }
    });
}

// 恢复已归档的积分活动
export function unarchivePointActivity(activityId) {
    return request({
        url: '/api/points/unarchivePointActivity',
        method: 'post',
        data: {
            activityId
        }
    });
}

// 获取未归档的积分活动列表
export function getPointActivityListWithActive(params) {
    return request({
        url: '/api/points/getPointActivityListWithActive',
        method: 'get',
        params
    });
}

// 获取已归档的积分活动列表
export function getPointActivityListWithArchived(params) {
    return request({
        url: '/api/points/getPointActivityListWithArchived',
        method: 'get',
        params
    });
}

/**
 * 分配任务给用户
 * @param {Object} data
 * @param {string[]} data.userIds - 用户ID数组
 * @param {string[]} data.activityIds - 活动ID数组
 * @param {string} data.assignDate - 分配日期 YYYY-MM-DD
 */
export function assignTasks(data) {
    return request({
        url: '/api/points/assignTasks',
        method: 'post',
        data
    });
} 